<template>
  <section class="hero">
    <div class="hero-background">
      <img src="../assets/images/hero-bg.jpg" class="bg-image bg-image-desktop" alt="背景图片" />
      <img src="../assets/images/hero-bg-mobile.jpg" class="bg-image bg-image-mobile" alt="移动端背景图片" />
      <div class="shape star-1">★</div>
      <div class="shape star-2">★</div>
      <div class="shape diamond">◆</div>
    </div>
    
    <a href="#download" class="download-overlay-button"></a>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style scoped>
.hero {
  min-height: 100vh;
  height: 1253px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.download-overlay-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: transparent;
  cursor: pointer;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1253px;
  z-index: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}

.bg-image-desktop {
  display: block;
}

.bg-image-mobile {
  display: none;
}

.shape {
  position: absolute;
  font-size: 24px;
  color: white;
  z-index: 1;
}

.star-1 {
  top: 20%;
  left: 15%;
  font-size: 30px;
  color: white;
}

.star-2 {
  bottom: 25%;
  right: 18%;
  font-size: 20px;
  color: #FFEB3B;
}

.diamond {
  bottom: 30%;
  left: 25%;
  font-size: 18px;
  color: #FF6B8B;
}

.hero-container {
  position: relative;
  z-index: 1;
  text-align: center;
}

.app-logo {
  margin-bottom: 20px;
}

.logo-circle {
  width: 120px;
  height: 120px;
  background: white;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.logo-circle h1 {
  font-size: 36px;
  font-weight: 800;
  color: #6A1B9A;
  margin: 0;
  letter-spacing: -1px;
}

.logo-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  background: #FF6B8B;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-dot {
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.hero-content h2 {
  font-size: 36px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
  margin-top: 20px;
}

.hero-content p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
}

.hero-buttons {
  margin-bottom: 30px;
}

.small-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .bg-image-desktop {
    display: none !important;
  }
  
  .bg-image-mobile {
    display: block !important;
    z-index: -1;
  }
  
  .hero {
    height: auto;
    min-height: 100vh;
  }
  
  .hero-background {
    height: 100%;
  }
  
  .logo-circle {
    width: 100px;
    height: 100px;
  }
  
  .logo-circle h1 {
    font-size: 28px;
  }
  
  .hero-content h2 {
    font-size: 30px;
  }
}
</style> 